// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { type RootAuthState } from '@shared/data-access/slices/auth/auth-state';
import { createTypedSelector } from '@shared/data-access/utils';

const createSelector = createTypedSelector<RootAuthState>();

export const selectAuthState = (state: RootAuthState) => state.auth;

export const selectToken = createSelector(selectAuthState, ({ token }) => token);

export const selectRefreshToken = createSelector(
  selectAuthState,
  ({ refreshToken }) => refreshToken,
);

export const selectExpirationDate = createSelector(
  selectAuthState,
  ({ expiration_date }) => expiration_date,
);

export const selectAuthUser = createSelector(selectAuthState, ({ user }) => user);

export const selectLoginError = createSelector(
  selectAuthState,
  ({ loginError }) => loginError,
);

export const selectIsAuthenticated = createSelector(
  selectAuthState,
  ({ token }) => token !== null,
);
